import { Worksheet } from 'constants/routes';
import { FIELDS } from 'store/carInstance/constants';

const { ROUTE_NAMES } = Worksheet;

export const VALID_ROUTES_FOR_SHOW = new Set([
  ROUTE_NAMES.CREATE_NEW_INSURANCE_ANKETA,
  ROUTE_NAMES.EDIT_INSURANCE_ANKETA,
]);

export const FIELDS_NAME = {
  CAR_ISSUE_DATE: FIELDS.carIssueDate,
};

export const MIN_DATE = new Date(1970, 0, 1);

export const MAX_DATE = new Date();
